import React from 'react'
import styled from 'styled-components'
import TikTok from 'images/magic/tiktok.svg'
import Linkedin from 'images/magic/linkedin.svg'
import Instagram from 'images/magic/instagram.svg'

const SocialMediaStyle = styled.section`
  width: 100%;
  display: flex;
  gap: 25px;
  justify-content: center;
  margin-top: 29px;
`

const LinkStyled = styled.a`
  width: 21px;
  height: 21px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: brightness(0);
`

const SocialMediaFooter = () => (
  <SocialMediaStyle>
    <LinkStyled
      href="https://www.instagram.com/joinflip/"
      aria-label="Instagram"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <Instagram />
    </LinkStyled>
    <LinkStyled
      href="https://www.tiktok.com/@joinflip"
      aria-label="TikTok"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <TikTok />
    </LinkStyled>
    <LinkStyled
      href="https://www.linkedin.com/company/myflipfit"
      aria-label="Linkedin"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <Linkedin />
    </LinkStyled>
  </SocialMediaStyle>
)

export default SocialMediaFooter
